import { Button, Stack, Tooltip } from '@mui/material';
import React from 'react';
import '../orders/Orders.scss';
import '../orders/UpcomingOrders.scss';
import { useTranslation } from 'react-i18next';
import { useCalendar } from '../calendar/CalendarContext/CalendarContext';
import { UseAuthPermissions } from '../session/UseAuthPermissions';
import { VouchersFilter } from './VouchersFilter/VouchersFilter';

const VouchersActions = () => {
  const { t } = useTranslation();

  const { readOnly } = UseAuthPermissions();

  const { openEditOrderDrawer } = useCalendar();
  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end">
      <VouchersFilter />
      <Tooltip title={readOnly ? t('noPermissions') : undefined}>
        <span>
          <Button
            disabled={readOnly}
            variant="contained"
            sx={{ textTransform: 'none' }}
            onClick={() => {
              openEditOrderDrawer({ createVoucher: true });
            }}>
            {t('vouchers.create')}
          </Button>
        </span>
      </Tooltip>
    </Stack>
  );
};

export default VouchersActions;
